import {BaseEntityUtils} from '../../app-common/data/BaseEntityUtils';
import {Customer} from './customer';
import {ReflectionUtils} from '../../virtual-scroll/services/reflection-utils';

export class CustomerUtils {

  static setDefaultProperties(target: Customer) {
    BaseEntityUtils.setDefaultProperties(target);
    target.isLead = false;
    target.contactName = '';
    target.phoneNumber = '';
    target.email = '';
    target.email2 = '';
    target.email3 = '';
    target.dba1 = '';
    target.address1 = '';
    target.address2 = '';
    target.city = '';
    target.state = '';
    target.zip = '';
    target.county = '';
    target.entityType = '';
    target.ein = '';
    target.notes = '';
    target.phoneNumberType = '';
    target.businessPhoneNumber = '';
    target.altPhoneNumber = '';
    target.altPhoneNumberType = '';
  }

  static clone(original: Customer, target: Customer) {
    ReflectionUtils.copyAttributes(original, target);
  }
}
